import BActionButton from "./BActionButton";
import BCustomButton from "./BCustomButton";
import BApprovalBtn from "./BApprovalBtn";
import BRoundButton from "./BRoundButton";
import MRoundButton from "./MRoundButton";

const CustomButton = {
    BActionButton,
    BCustomButton,
    BApprovalBtn,
    BRoundButton,
    MRoundButton
};

export default CustomButton;
